import React from 'react';
import styles from 'components/MainHeader/MainHeader.module.css';

export const SandboxModeLabel = () => (
    <p className={styles.sandboxModeLabel}>
        Sandbox mode
    </p>
);
